module.exports = __webpack_public_path__ + "img/ic_bike2.5dfd821b.png";